const route = {
	path: '/your_plan',
	name: 'your_plan',
	meta: {
		noChangeCompany: true,
		title: 'Tu plan',
	},
	component: () => import('@/pages/your-plan/page-your-plan'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/your-plan.js